import Marionette from 'backbone.marionette';

import template from "../templates/signupForm.ejs";

export default Marionette.View.extend( {

   template: template,

   templateContext: function () {
      return this.app.data
   },

   ui: {
      manageSubmit: '#signup-submit',
      interests: '[data-interest-checkbox]'
   },

   events: {
      'submit': 'interestsSubmitted',
   },

   modelEvents: {
      'change:interests': 'interestsChanged'
   },

   initialize: function ( options ) {
      this.mergeOptions( options, ['app'] );
   },

   interestsChanged: function ( model, values = {}, options ) {
      this.getUI( 'interests' ).each( function () {
         this.checked = values[this.name];
      } );
   },

   interestsSubmitted: function ( event ) {
      if( this.getUI( 'manageSubmit' ).hasClass( 'disabled' ) ) {
         return false
      }
      this.getUI( 'manageSubmit' ).addClass( 'loading disabled' );
      this.model.save( {
         status: 'subscribed',
         interests: this.getUI( 'interests' ).get().reduce( ( result, checkbox ) => {
            return Object.assign( result, {[checkbox.name]: checkbox.checked} )
         }, {} )
      }, {
         success: () => {
            const btnLabel = this.getUI( 'manageSubmit' ).html();
            this.getUI( 'manageSubmit' ).removeClass( 'loading disabled' ).text( 'Saved' );
            setTimeout( () => this.getUI( 'manageSubmit' ).html( btnLabel ), 5000 );

            this.app.showAlert('alert-success', this.app.data.alerts.signupSuccess);
         },
         error: ( model, response ) => {
            this.getUI( 'manageSubmit' ).removeClass( 'loading disabled' );
            if( response.status === 0 ) {
               this.app.showAlert('alert-danger', this.app.data.alerts.networkError);
            }
            else {
               this.app.showAlert('alert-danger', this.app.data.alerts.applicationError);
            }
         },
      } );
      return false
   },
} );



// WEBPACK FOOTER //
// ./news/components/SignupView.js